/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const FlagMutationData = core.serialization.object({
    label: core.serialization.string().optional(),
    colorHex: core.serialization.string().optional(),
});
